import type { AddFieldOption } from '@cli-types/core-engine/add-field.js'
import type { AddFieldCommandOptions } from '@cli-types/core-engine/commands.js'
import { parseAddFieldOptions } from '@core-engine/schema/add-field/parse-add-field-options.js'
import { fail } from '../schema-prompts/fail.js'

export function normalizeOptionList(options: AddFieldCommandOptions): AddFieldOption[] {
  try {
    return parseAddFieldOptions(options.option)
  } catch (error) {
    fail(error instanceof Error ? error.message : String(error))
  }
}
